import React from 'react';
import AdvertiserLoginBox from '@client/containers/AdvertiserLoginBox/LoginBox';

const LoginPage = () => {
  return <AdvertiserLoginBox />;
};

export default LoginPage;
